<template>

	<TopMenu :breadcrumbs="breadcrumbs"/>

	<div class="load-container" :class="{'load' : isLoad}"></div>

	<template v-if="!isLoad">
    <template v-if="companies.length > 1">
      <CollapseContainer v-for="company in companies" :key="company.id" class="collapse--transparent">
        <template v-slot:header>
          <div class="c-collapse-count"> {{ company.houses.length }} </div>
          <div class="c-collapse-name"> 
            {{ company.name }} 
            <div class="c-collapse-badge" v-if="company.badge > 0"> {{ company.badge }}</div> 
          </div>
        </template>
        <template v-slot:body>
          <HousePreview :house="house" :company="company" v-for="house in company.houses" :key="house.id"/>
        </template>
      </CollapseContainer>
    </template>
    <template v-else>
      <HousePreview :house="house" :company="companies[0]" v-for="house in companies[0].houses" :key="house.id" />
    </template>
	</template>
	
</template>

<script setup>
  import TopMenu from '@/components/TopMenu.vue'
  import HousePreview from '@/components/tracker/HousePreview.vue'
  import CollapseContainer from '@/components/ux/CollapseContainer.vue'
</script>

<script>

  export default {
    name: 'PageTracker',

    data: () => ({
      isLoad: true,
      breadcrumbs: [],
      companies: null,
    }),
    computed: {
      badge () {
        return this.$store.state.badge;
      },
    },
    created () {
      this.breadcrumbs = [
        {name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico}
      ];
      Promise.all([this.loadData()])
      .then(() => {
        this.beforeRender();
      })
      .catch((e)=> {
        console.log(e);
      })
      .finally(()=> {
        this.isLoad = false;
      })
    },
    methods: {
    	beforeRender () {
    	},
      async loadData () {
        const { companies } = await this.$store.dispatch('getTrackerObjects');
        this.companies = companies;
        for (let i in this.companies) {
          this.companies[i].badge = this.companies[i].id in this.badge.companies ? this.badge.companies[this.companies[i].id].count : 0;
          for (let hi in this.companies[i].houses) {
            this.companies[i].houses[hi].badge = this.companies[i].houses[hi].id in this.badge.companies[this.companies[i].id].houses ? this.badge.companies[this.companies[i].id].houses[this.companies[i].houses[hi].id].count : 0;
          }
        }
      },
    },
  }
</script>

<style scoped>
  .block {
    margin-bottom: 10px;
  }
  .collapse:not(:last-child) {
    margin-bottom: 5px;
  }
  .c-collapse-count {
    background: #E9F1F4;
    height: 30px;
    width: 30px;
    border-radius: 30px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.05em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    color: var(--cozh-blue);
  }
  .collapse:deep(.collapse__header) {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #0B2836;
    word-wrap: break-word;
  }
  .c-collapse-name {
    position: relative;
  }
  .c-collapse-badge {
    position: absolute;
    right: -5px;
    top: -10px;
    background-color: var(--cozh-red);
    color: var(--cozh-white);
    font-size: 10px;
    font-weight: 500;
    line-height: 1;
    padding: 4px 7px;
    border-radius: 4px;
    transform: translateX(100%);
    min-width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>